import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {setFavoriteGroup, fetchFavoriteItems, clearFavorite, delFavoriteGroup, addAllToCart} from '../actions/FavoriteAppActions';
import {bindActionCreators} from "redux";
import FavoriteProduct from "./FavoriteProduct";
import FavoriteLoadingProduct from "./FavoriteLoadingProduct";
import Pagination from "./Pagination";
import {NLoader} from './NLoader';


const Favorite  = (props, attrs) => {

  const {setFavoriteGroup, fetchFavoriteItems, clearFavorite, delFavoriteGroup, addAllToCart} = props

  const checked_count = props.items.reduce((counter, obj) => {
      if (obj.checked) counter += 1;
      return counter;
      }, 0);

  const loading_count = 4;
  const not_loaded = (props.items.length === 0 && props.count > 0) ? true : false;

  useEffect(() => {
      if (not_loaded){
          fetchFavoriteItems();
      }
  },[props.count]);

  useEffect(() => {
      fetchFavoriteItems();
  },[props.page, props.group]);

  const getColorTag = (ind) => {
      const colors = [
          "blue", "indigo", "pink", "red", "purple", "orange", "yellow", "green", "teal",  "black", "cyan",
      ]
      return colors[ind % colors.length]
  }

  const handleSetGroup = (e, group) =>{
      if (group!==props.group){
        setFavoriteGroup(group);
      }
      e.preventDefault();
  }
  const handleDelGroup = (e, group) =>{
      if (group!==""){
        delFavoriteGroup(group);
      }
      e.preventDefault();
  }

  return (
      <div>
          <div className="nheader">
              {props.status === 'ERROR' ?
                  <div className="alert alert-danger">
                      <strong>Упс!</strong> Произошла ошибка. Для продолжения работы обновите страницу (Нажмите F5).
                  </div>
                  :
                  <>
                      <h2 className={'pb-3'}>Избранное
                          ({checked_count === props.count ? props.count : `${checked_count}/${props.count}`})
                          {checked_count > 0 ?
                              <>
                                  <span className="ncart-delete-all"
                                        onClick={e => clearFavorite()}>
                                      <i className="material-icons">delete</i>
                                  </span>
                                  <span className="ncart-delete-all me-2"
                                        onClick={e=>addAllToCart()}>
                                      <i className="material-icons">add_shopping_cart</i>
                                  </span>
                              </>
                              :
                              null
                          }
                      </h2>
                          {props.groups.length > 0 ?
                              <div className="col-12 group-selet-container">
                              <span className={'fh-2'}>Списки:</span>
                      <a className="btn rounded-5 mark-btn mx-1 mb-1 text-truncate"
                         data-tags={props.group.length > 0 ? 'danger' : 'selected'}
                                 href="#"
                                 type="button"
                                 onClick={e => handleSetGroup(e, "")}>
                                  <span>
                                      Все избранное
                                  </span>
                              </a>
                                  {props.groups.map((group_item, group_ind) => (
                                      <a className="btn rounded-5 mark-btn mx-1 mb-1 text-truncate"
                                         data-tags={group_item===props.group ? 'selected': getColorTag(group_ind)}
                                         key={group_ind}
                                         href="#" type="button">
                                  <span onClick={e => handleSetGroup(e, group_item)}>
                                      {group_item}
                                  </span>
                                          <i className="material-icons del-group ms-1"
                                             onClick={e => handleDelGroup(e, group_item)}>
                                              close
                                          </i>
                                      </a>
                                  ))}
                          </div>
                          :
                          null
                      }
                  </>
              }
          </div>
          {props.count === 0 ?
          <div className="nbody">
              <div className="row ncart-empty">
                  <h2>Пока ничего не добавленно в Избранное</h2>
              </div>
          </div>
          :
          <>
          <div className="nbody">
                      <div className="ncart-detail-item">
                          {not_loaded ?
                              [...Array(loading_count)].map((x, i) =>
                                  <FavoriteLoadingProduct key={i}/>
                              )
                              :
                              props.items.map((item, key) => (
                                  <FavoriteProduct item={item} groups={props.groups} key={item.id} index={key}/>
                              ))
                      }
                      { not_loaded &&<div className="ncart-loader"> <NLoader size="pl-size-l"/></div>}
                  </div>
              </div>
              <div className="nheader total">
                  <div className="row">
                      <div className="col-12">
                          <Pagination/>
                      </div>
                  </div>
               </div>
          </>
          }
      </div>
)}

const mapStateToProps = state => ({
    page: state.favorite.page,
    page_size: state.favorite.page_size,
    count: state.favorite.count,
    status: state.favorite.status,
    next: state.favorite.next,
    previous: state.favorite.previous,
    items: state.favorite.items,
    group: state.favorite.group,
    groups: state.favorite.groups,
    extra_rows: state.favorite.extra_rows
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setFavoriteGroup,
    fetchFavoriteItems,
    clearFavorite,
    delFavoriteGroup,
    addAllToCart
}, dispatch);

export default connect(
  mapStateToProps, mapDispatchToProps
)(Favorite)
